import styled from 'styled-components';

export const ShowMoreContainer = styled.div`
  width: 300px;
  margin: 0 auto;
  padding-top: 50px;
`;
